import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { MmDialogConfig, MmDialogService } from '@metromarkets/components';
import { Observable, combineLatest, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { CheckoutService } from '~app/modules/checkout/services';
import { ExtendImpersonationSessionDialogComponent } from '~shared/components/extend-impersonation-session-dialog/extend-impersonation-session-dialog.component';
import { FeatureToggleEnum } from '~shared/constants';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { ExtendImpersonationSessionMap } from '../services/extend-impersonation-session-map.service';

@Injectable()
export class ExtendImpersonationTokenInterceptor implements HttpInterceptor {
  readonly AUTH_FAIL_ERROR = 'AccountInfoDTO has no customer (Not impersonated yet?).';
  readonly UNAUTHORIZED_CODE = 401;
  private static impersonatedAuthFailed: boolean = false;
  constructor(private injector: Injector) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((e) => {
        if (
          e?.status === this.UNAUTHORIZED_CODE &&
          e?.title === this.AUTH_FAIL_ERROR &&
          ExtendImpersonationSessionMap.isScopeActive() &&
          !ExtendImpersonationTokenInterceptor.impersonatedAuthFailed
        ) {
          const activeFeaturesConfigCatService = this.injector.get(ActiveFeaturesConfigcatService);
          const checkoutService = this.injector.get(CheckoutService);
          combineLatest([
            activeFeaturesConfigCatService.isFeatureEnabled(FeatureToggleEnum.FF_IMPERSONATION_SESSION_EXTEND),
            checkoutService.getAssistedSalesFlag(),
          ])
            .pipe(take(1))
            .subscribe(([flag, isAssistedSales]) => {
              if (flag && isAssistedSales) {
                ExtendImpersonationTokenInterceptor.impersonatedAuthFailed = true;
                const dialogConfig = new MmDialogConfig();
                dialogConfig.data = {
                  id: 1,
                  title: 'Extend Impersonation Session',
                  reloadPostRefresh: true,
                };
                this.injector.get(MmDialogService).open(ExtendImpersonationSessionDialogComponent, dialogConfig);
              }
            });
        }
        return throwError(e);
      })
    );
  }

  static resetImpersonatedAuthFailed() {
    this.impersonatedAuthFailed = false;
  }
}
